<template>
  <fragment>
    <default v-if="type === 'default'" />
    <dualRing v-if="type === 'dualRing'" />
    <ellipsis v-if="type === 'ellipsis'" />
    <facebook v-if="type === 'facebook'" />
    <grid v-if="type === 'grid'" />
    <hourglass v-if="type === 'hourglass'" />
    <ring v-if="type === 'ring'" />
    <ripple v-if="type === 'ripple'" />
    <roller v-if="type === 'roller'" />
    <spinner v-if="type === 'spinner'" />
    <bar v-if="type === 'bar'" />
    <chart v-if="type === 'chart'" />
    <bankLoading v-if="type === 'bankLoading'" />
  </fragment>
</template>
<script>
// https://loading.io/css/
// https://tobiasahlin.com/spinkit/
import $default from "./PdkDefault";
import dualRing from "./PdkDualRing";
import ellipsis from "./PdkEllipsis";
import facebook from "./PdkFacebook";
import grid from "./PdkGrid";
import hourglass from "./PdkHourglass";
import ring from "./PdkRing";
import ripple from "./PdkRipple";
import roller from "./PdkRoller";
import spinner from "./PdkSpinner";
import bar from "./pdkBar";
import chart from "./pdkChart";
import bankLoading from "./PdkBankLoading.vue";

export default {
  name: "loading-bar",
  components: {
    default: $default,
    dualRing,
    ellipsis,
    facebook,
    grid,
    hourglass,
    ring,
    ripple,
    roller,
    spinner,
    bar,
    chart,
    bankLoading,
  },
  props: {
    type: { type: String, default: "default" },
  },
  mounted: function () {
    switch (this.type.toLowerCase().trim()) {
      case "dualRing":
      case "ellipsis":
      case "facebook":
      case "grid":
      case "hourglass":
      case "ring":
      case "ripple":
      case "roller":
      case "spinner":
      case "bar":
      case "chart":
        this.type = this.type.toLowerCase().trim();
        break;

      default:
        this.type = "default";
    }
  },
};
</script>